export default "__VITE_ASSET__a51973eb__"